import * as MsDyn365 from '@msdyn365-commerce/core';
import * as React from 'react';
import { ILxsWelcomeViewProps } from './lxs-welcome';

type WelcomeRichTextField =
    | 'existingCustomerTitle'
    | 'existingCustomerDescription'
    | 'existingCustomerChecklist'
    | 'requestAccessTitle'
    | 'requestAccessDescription'
    | 'requestAccessChecklist';

const getRichTextValue = (props: ILxsWelcomeViewProps, field: WelcomeRichTextField) => {
    switch (field) {
        case 'existingCustomerTitle':
            return props.config.existingCustomerTitle;
        case 'existingCustomerDescription':
            return props.config.existingCustomerDescription;
        case 'existingCustomerChecklist':
            return props.config.existingCustomerChecklist;
        case 'requestAccessTitle':
            return props.config.requestAccessTitle;
        case 'requestAccessDescription':
            return props.config.requestAccessDescription;
        case 'requestAccessChecklist':
            return props.config.requestAccessChecklist;
    }
};

const setRichTextValue = (props: ILxsWelcomeViewProps, field: WelcomeRichTextField, value: string) => {
    switch (field) {
        case 'existingCustomerTitle':
            props.config.existingCustomerTitle = value;
            break;
        case 'existingCustomerDescription':
            props.config.existingCustomerDescription = value;
            break;
        case 'existingCustomerChecklist':
            props.config.existingCustomerChecklist = value;
            break;
        case 'requestAccessTitle':
            props.config.requestAccessTitle = value;
            break;
        case 'requestAccessDescription':
            props.config.requestAccessDescription = value;
            break;
        case 'requestAccessChecklist':
            props.config.requestAccessChecklist = value;
            break;
    }
};

const renderRichText = (props: ILxsWelcomeViewProps, field: WelcomeRichTextField, className: string) => {
    const value = getRichTextValue(props, field);

    if (!value) {
        return null;
    }

    return (
        <div className={className}>
            <MsDyn365.RichTextComponent
                text={value}
                editProps={{
                    onEdit: event => setRichTextValue(props, field, event.target.value),
                    requestContext: props.context.request
                }}
            />
        </div>
    );
};

const LxsWelcomeView: React.FC<ILxsWelcomeViewProps> = props => {
    const className = 'lxs-welcome';
    const existingCustomerUrl =
        props.config.existingCustomerButtonLink?.linkUrl.destinationUrl || props.context.request.user.signInUrl || '#';
    const requestAccessUrl = props.config.requestAccessButtonLink?.linkUrl.destinationUrl || '#';

    return (
        <section className={className}>
            <div className={`${className}__grid`}>
                <article className={`${className}__card ${className}__card--signin`}>
                    <div className={`${className}__icon ${className}__icon--user`} />
                    {props.config.existingCustomerBadge ? (
                        <span className={`${className}__badge`}>{props.config.existingCustomerBadge}</span>
                    ) : null}
                    {renderRichText(props, 'existingCustomerTitle', `${className}__title`)}
                    {renderRichText(props, 'existingCustomerDescription', `${className}__description`)}
                    {renderRichText(props, 'existingCustomerChecklist', `${className}__checklist`)}
                    <a href={existingCustomerUrl} className={`msc-cta__secondary ${className}__button`}>
                        {props.config.existingCustomerButtonText}
                    </a>
                </article>

                <article className={`${className}__card ${className}__card--request`}>
                    <div className={`${className}__icon ${className}__icon--user-add`} />
                    {props.config.requestAccessBadge ? (
                        <span className={`${className}__badge`}>{props.config.requestAccessBadge}</span>
                    ) : null}
                    {renderRichText(props, 'requestAccessTitle', `${className}__title`)}
                    {renderRichText(props, 'requestAccessDescription', `${className}__description`)}
                    {renderRichText(props, 'requestAccessChecklist', `${className}__checklist`)}
                    <a href={requestAccessUrl} className={`msc-cta__secondary ${className}__button`}>
                        {props.config.requestAccessButtonText}
                    </a>
                </article>
            </div>
        </section>
    );
};

export default LxsWelcomeView;
